<div class="container">
    <h1 class="page-title">Application for Assistance for {{ administrativeFundName }}</h1>
    <div class="application-message-wrapper" *ngIf="applicationType === AssistanceApplicationType.STLWater">
        <p>
            During the 2020 Pandemic, the City of St. Louis Water Services Division instituted a water
            shut-off-moratorium
            for residents, a common practice for cities during the pandemic. $1 million of American Rescue Plan Act
            (ARPA)
            funds has been allocated to assist residents with past-due water accounts. This assistance program also
            includes
            a financial literacy component and mandatory enrollment in a repayment plan to ensure that residents can pay
            off
            their water debt in full.
            <br/><br/>
            Funds will be awarded on a first-come, first-served basis and consist of a one-time credit of up to $500.
        </p>
    </div>
    <div class="alert alert-danger mt-5" *ngIf="!hasIncome(client?.individualMonthlyIncome)">The client record must
        have an individual monthly income to create an application. Please edit the client record and fill out their
        individual monthly income before proceeding.
    </div>
    <section class="widget">
        <app-assistance-application-form [client]="client" [user]="user" [isNewApplication]="true"
                                         [defaultOpenDocumentUpload]="true" [applicationType]="applicationType"
                                         [formValuesSet]="true"
        >
            <div class="alert alert-danger mt-5" *ngIf="!hasIncome(client?.individualMonthlyIncome)">The client record
                must have an individual monthly income to create an application. Please edit the client record and fill
                out their individual monthly income before proceeding.
            </div>

            <button class="btn btn-primary pull-right" style="margin-left: 10px;" (click)="submit()">Create Case</button>
            <button class="btn btn-secondary pull-right" (click)="saveDraft()">Save as Draft</button>
        </app-assistance-application-form>
    </section>
</div>
<prompt-dialog
        [titleText]="'Client County Inactive'"
        promptText="{{clientCountyInactiveMessage}}">
</prompt-dialog>
